
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getDevice, productList } from '@/api/device';

@Component({
  name: 'GroupTag',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: []
  })
  selectDevice!: [];

  private brandList: any = {};
  private productList: any = {};
  private moduleList: any = {};
  private form: any = {};

  private deviceTableData: any = [];
  private deviceSelected: any = [];
  private deviceTopMultipleSelection:any=[];
  private checkAllDevice = false;
  private isIndeterminate: any = null;

  private listLoading = false

  created() {
    this.deviceTopMultipleSelection = this.selectDevice;
    this.getDeviceList();
    this.getBrand('', 1);
  }

  private checkAllDeviceChange(val:any) { // 全选
    let deviceOptions:any = [];
    if (val) {
      this.deviceTableData.forEach((element:any) => {
        deviceOptions.push(element);
      });
    }
    this.deviceTopMultipleSelection = deviceOptions;
    this.deviceSelected = deviceOptions;

    this.isIndeterminate = this.deviceSelected.length === this.deviceTableData.length;
    this.$emit('changeDeviceChange', this.deviceTopMultipleSelection);
  }
  private changeDeviceChange(row:any) { // 单选
    let checkedCount = this.deviceSelected.length;
    let _length = this.deviceTableData.length;

    for (let i = 0; i < this.deviceTableData.length; i++) {
      if (this.deviceTableData[i].list) {
        _length += this.deviceTableData[i].list.length;
      }
    }
    this.checkAllDevice = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
    let arr = this.deviceSelected.filter((device:any) => {
      return device.id === row.id
    })
    if (arr && arr.length > 0) {
      this.deviceTopMultipleSelection.push(row)
    } else {
      this.deviceTopMultipleSelection.splice(this.deviceTopMultipleSelection.indexOf(row), 1)
    }
    this.$emit('changeDeviceChange', this.deviceTopMultipleSelection);
  }
  private currentPage=1;
  private totalPage=1;
  private search() {
    this.getDeviceList();
  }
  private reset() {
    this.form = {
      brand: {},
      product: {},
      model: {},
      customer: {}
    };
    this.productList = [];
    this.moduleList = [];
    this.currentPage = 1;
    this.getDeviceList();
  }
  private loadMore() {
    this.currentPage = this.currentPage + 1;
    this.getDeviceList()
  }
  private getDeviceList() {
    this.listLoading = true;
    const params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      page: this.currentPage,
      size: 10
    };

    if (this.form.number) {
      params.number = this.form.number;
    }

    if (this.form.sn) {
      params.sn = this.form.sn;
    }
    if (this.form.brand && this.form.brand.id) {
      params.brand_id = this.form.brand.id;
    }
    if (this.form.product && this.form.product.id) {
      params.product_id = this.form.product.id;
    }
    if (this.form.model && this.form.model.id) {
      params.model_id = this.form.model.id;
    }
    getDevice(params).then(res => {
      if (res.data) {
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].pname = '';
        }
        if (this.currentPage === 1) {
          this.deviceTableData = res.data.list;
        } else {
          this.deviceTableData = this.deviceTableData.concat(res.data.list);
        }
        this.totalPage = res.data.page_count;
        this.setSelect(this.deviceTableData);
      } else {
        if (this.currentPage === 1) { this.deviceTableData = []; }
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  private setSelect(list: any) {
    if (this.selectDevice && this.selectDevice.length > 0) {
      for (let i = 0; i < this.selectDevice.length; i++) {
        let item: any = this.selectDevice[i];
        for (let m = 0; m < list.length; m++) {
          let element: any = list[m];
          if (element.device_id === item.id) {
            let arr = this.deviceSelected.filter((v: any) => {
              return v.device_id === item.id;
            });
            if (!arr || arr.length < 1) {
              this.deviceSelected.push(element);
            }
          }
          if (element.list) {
            this.setSelect(element.list);
          }
        }
      }
      let _length = this.deviceTableData.length;
      for (let i = 0; i < this.deviceTableData.length; i++) {
        if (this.deviceTableData[i].list) {
          _length += this.deviceTableData[i].list.length;
        }
      }
      if (this.deviceSelected.length === _length) {
        this.checkAllDevice = true;
        this.isIndeterminate = false;
      } else if (this.deviceSelected.length === 0) {
        this.checkAllDevice = false;
        this.isIndeterminate = false;
      } else {
        this.checkAllDevice = false;
        this.isIndeterminate = true;
      }
    }
  }
  private deviceHandleCloseTag(item:any, index:number) {
    this.deviceTopMultipleSelection.splice(index, 1);
    this.deviceSelected.splice(index, 1);
    let checkedCount = this.deviceSelected.length;
    let _length = this.deviceTableData.length;
    this.checkAllDevice = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  private getBrand(id: string, type: number) {
    let parameters: any = {};
    parameters.company_id = UserModule.getCompanyId;
    parameters.product_type = type;
    switch (type) {
      case 1:
        break;
      case 2:
        parameters.brand_id = id;
        break;
      case 3:
        parameters.brand_id = this.form.brand.id;
        parameters.product_id = id;
        break;
    }

    productList(parameters)
      .then((res) => {
        switch (type) {
          case 1:
            if (res.data) {
              this.brandList = res.data.list;
            } else {
              this.brandList = [];
            }

            break;
          case 2:
            if (res.data) {
              this.productList = res.data.list;
            } else {
              this.productList = [];
            }

            break;
          case 3:
            if (res.data) {
              this.moduleList = res.data.list;
            } else {
              this.moduleList = [];
            }

            break;
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  private brandChange(val: any) {
    this.form.product = {};
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 2);
    } else {
      this.productList = [];
    }
  }
  private productChange(val: any) {
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 3);
    } else {
      this.moduleList = [];
    }
  }
  private moduleChange(val: any) {
    this.getBrand(this.form.product.id, 3);
  }
}
